/**
 * loginLinkAdapter — ce que `POST api/v1/login-link` rend, et le nom qu'on montre d'un compte.
 *
 * La réponse est celle d'une connexion (le jeton, le compte, ses comptes de famille, `method`) ;
 * elle n'a pas de case de réducteur et ne va nulle part avant que la personne ait choisi
 * (`acceptLoginLink` la range, et seulement lui).
 */

export type ApiLoginLinkUser = {
    id?: number | null
    email?: string | null
    firstname?: string | null
    lastname?: string | null
    roles?: string[] | null
}

export type ApiLoginLinkSuccess = {
    token?: string
    method?: string
    user?: ApiLoginLinkUser | null
    family_tokens?: unknown[] | null
}

/**
 * Le prénom et le nom, à défaut l'e-mail — port littéral de `nameOf` (`src/auth/LoginLinkScreen.js`).
 * Rien du tout rend une chaîne vide, que la page lit comme « pas de nom ».
 */
export function accountDisplayName(user: ApiLoginLinkUser | null | undefined): string {
    const name = [user?.firstname, user?.lastname].filter(Boolean).join(" ")
    return name || user?.email || ""
}
